import React from 'react';

import './DisclaimerText.scss';

function DisclaimerText({ setRef }) {
  return (
    <div className="mn_nagDisclaimerText" ref={setRef}>
      <p>*This "New Member" bonus offer (the "Bonus Offer") is available only to new members of the
        MileagePlus Shopping<sup>SM</sup> site (the "Site") who complete a "qualifying purchase(s)"
        (defined below) within two weeks of signing up for the MileagePlus Shopping program for
        the first time (the "Bonus Period"). Please refer to your MileagePlus Shopping Welcome
        emails for the specific expiration date for this Bonus Offer (i.e., the end date for the
        Bonus Period). During the Bonus Period, Member will receive five hundred (500) MileagePlus
        miles ("Bonus Awards Miles") when they make qualifying purchase(s) through MileagePlus
        Shopping totaling $25.00 or more. Member must login and make the qualifying purchase(s)
        through the Site during the Bonus Period. Please allow 6 to 8 weeks for Bonus Award Miles
        to post to your MileagePlus Shopping account. "Qualifying purchases" do not include product
        returns or cancellations, gift card purchases, and certain products identified by the
        individual merchant. Individual merchants may have additional terms and conditions on
        their store details page on the Site, which terms and conditions will apply to this Bonus Offer.
        Each new MileagePlus Shopping mall account is eligible for a maximum of one (1) Bonus Award
        Miles reward. All Mileage Plus Shopping program rules and regulations apply.
        Void where prohibited by law.
      </p>
      <p>**MileagePlus Credit Card Members will receive one thousand (1000) MileagePlus miles
        ("Bonus Awards Miles") when they make qualifying purchase(s) through MileagePlus Shopping
        totaling $25.00 or more. Member must login and make the qualifying purchase(s) through the
        Site during the Bonus Period. Please allow 6- 8 weeks for Bonus Award Miles to post to your
        MileagePlus Shopping account. "Qualifying purchases" do not include product returns or
        cancellations, gift card purchases, and certain products identified by the individual merchant.
        Individual merchants may have additional terms and conditions on their store details page on
        the Site, which terms and conditions will apply to this Bonus Offer.
        Each new MileagePlus Shopping mall account is eligible for a maximum of one (1)
        Bonus Award Miles reward. All Mileage Plus Shopping program rules and regulations apply.
        Void where prohibited by law.
      </p>
    </div>
  );
}

export default DisclaimerText;
